import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { map, filter } from 'rxjs/operators';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { SystemConfigurationResponseDTO, SystemConfigurations } from '../DTOs/response/system-configuration-response-dto';
import { BeamIndentification } from '../interfaces/beam-indentification';
import { CoverageLevel } from '../interfaces/coverage-level';
import { Partners } from '../interfaces/partners';
import { ReceiverManufacturer } from '../interfaces/receiver-manufacturer';
import { ServiceDuration } from '../interfaces/service-duration';
import { SystemConfigurationService } from '../services/system-configuration.service';
import { BeamResponseDTO } from '../DTOs/response/beam-response-dto';
import { ResponseDTO } from '../DTOs/response/response-dto';
import { DataTranslationService } from '../services/data-translation.service';
import { CoverageLevelResponseDTO } from '../DTOs/response/covergae-level-response-dto';
import { Router } from '@angular/router';
import { PartnerDataService } from '../services/partner-data.service';
import { Subject } from 'rxjs';
import { ProgressData } from 'src/app/modules/shared/dtos/progress-data';
import { ProgressIndicatingService } from 'src/app/modules/shared/services/progress-indicating.service';

@Component({
    selector: 'app-system-configuration',
    templateUrl: './system-configuration.component.html',
    styleUrls: ['./system-configuration.component.scss']
})
export class SystemConfigurationComponent implements OnInit {
    public loading: boolean = false;
    public isDataAvailable: boolean = false;
    public isError: boolean = false;
    public spnieerMsg: string = 'Retrieving data';
    public onAddItems: boolean = false;
    public onAddPartnerItems: boolean = false;
    public onAddDialogHeader: string = '';
    public clonedBeams: { [s: string]: BeamIndentification; } = {};
    public beamsGridInfo: BeamIndentification[] = [];
    public newBeam: string = '';
    public newBeamLongitude: string = '';
    public clonedCoverages: { [s: string]: CoverageLevel; } = {};
    public coverageGridInfo: CoverageLevel[] = [];
    public newCoverage: string = '';
    public newCoverageBeams: string = '';
    public clonedServiceDurations: { [s: string]: ServiceDuration; } = {};
    public serviceDurationGridInfo: ServiceDuration[] = [];
    public newDuration: string = '';
    public newDurationUnits: string = '';
    public clonedrxManufacturers: { [s: string]: ReceiverManufacturer; } = {};
    public rxManufacturersGridInfo: ReceiverManufacturer[] = [];
    public newrxManufacturers: string = '';
    public clonedPartners: { [s: string]: Partners; } = {};
    public partnersGridInfo: Partners[] = [];
    public newPartnerName: string = '';
    public newPartnerEmail: string = '';
    public selectedNewPartnerType: string = '';
    public newPartnerOptions: { name: string, code: string }[] = [];
    public errorMessage: string = '';
    public errorResponseCode: boolean = false;
    public testActivationLimit: string|null = '';
    public supportActivationLimit: string|null = '';
    public initialTestActivationLimit: number = 0;
    public initialSupportActivationLimit: number = 0;
    private testActivationLimitAPIData: number = 0;
    public isTestActivationLimitChanged: boolean = true;
    private progress$ = new Subject<ProgressData>();
    private configDTO: SystemConfigurations;
    public beamEnable: boolean = false;
    public serviceDurationEnable: boolean = false;
    public coverageLevEnable: boolean = false;
    public rxManfuEnable: boolean = false;

    public issupportActivationLimitChanged: boolean = true;
    private supportActivationLimitAPIData: number = 0;
    public showMessage : string = '';
    public showErrorMessage : string = '';

    public beamCount : number;

    public constructor(private _confirmationService: ConfirmationService,
        private _systemConfigService: SystemConfigurationService,
        private _dataTranslationService: DataTranslationService,
        private _partnerDataService: PartnerDataService,
        private _progressIndicatingService: ProgressIndicatingService,
        private messageService: MessageService,
        public fb: FormBuilder, private _router: Router) { }

    public beamForm = this.fb.group({
        beamId: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[a-zA-Z0-9 ]+(?:[-:%/\\()\u2122.+][a-zA-Z0-9 ]+)*$/)
            ]
        ),
        satelliteLongitude: new FormControl('',
            [
                Validators.required,
                Validators.min(-180),
                Validators.max(180),
                Validators.pattern(/^-?\d{1,10}(\.\d{1,1})?$/)
            ]
        )
    })

    public serviceDurationForm = this.fb.group({
        duration: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[0-9]+$/)
            ]
        ),
        durationUnits: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[a-zA-Z\s]*$/)
            ]
        )
    })

    public coverageLevelForm = this.fb.group({
        coverageLevel: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[a-zA-Z\s]*$/)
            ]
        ),
        noOfBeams: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[0-9]+$/),
                // Validators.max(9),
                Validators.min(1)
            ]
        )
    });

    public rxManufacturerForm = this.fb.group({
        manufactureName: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[a-zA-Z0-9]+$/)
            ]
        )
    });

    public addNewDetailsForm = this.fb.group({
        newBeam: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[a-zA-Z0-9 ]+(?:[-:%/\\()\u2122.+][a-zA-Z0-9 ]+)*$/)
            ]
        ),
        newLongitude: new FormControl('',
            [
                Validators.required,
                Validators.min(-180),
                Validators.max(180),
                Validators.pattern(/^-?\d{1,10}(\.\d{1,1})?$/)
            ]
        ),
        newDuration: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[0-9]+$/)
            ]
        ),
        newDurationUnits: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[a-zA-Z\s]*$/)
            ]
        ),
        newCoverageLevel: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[a-zA-Z\s]*$/)
            ]
        ),
        newNoOfBeams: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[0-9]+$/),
                // Validators.max(9),
                Validators.min(1)

            ]
        ),
        newManufactureName: new FormControl('',
            [
                Validators.required,
                Validators.pattern(/^[a-zA-Z0-9]+$/)
            ]
        )
    })

    public ngOnInit(): void {
        this.showErrorMessage = '';
        this.showMessage = '';
        this.newPartnerOptions = [
            { name: 'Yes', code: 'Yes' },
            { name: 'No', code: 'No' }
        ];
        this.beamForm.get('beamId')?.valueChanges.subscribe((data: string) => {
            this.beamEnable = false;
            const beamObj = this.beamsGridInfo.find(x => x.beamId === data);
            if (beamObj !== null && beamObj !== undefined) {
                this.beamEnable = true;
            }
        });
        this.beamForm.get('satelliteLongitude')?.valueChanges.subscribe((data: string) => {
            this.beamEnable = false;
            // data = data.replace('"', '');
            const beamObj = this.beamsGridInfo.find(x => x.satelliteLongitude === data);
            if (beamObj !== null && beamObj !== undefined) {
                this.beamEnable = true;
            }
        });
        this.serviceDurationForm.get('duration')?.valueChanges.subscribe((data: number) => {
            this.serviceDurationEnable = false;
            const serObj = this.serviceDurationGridInfo.find(x => x.duration === data);
            if (serObj !== null && serObj !== undefined) {
                this.serviceDurationEnable = true;
            }
        });
        this.serviceDurationForm.get('durationUnits')?.valueChanges.subscribe((data: string) => {
            this.serviceDurationEnable = false;
            data = data.replace('"', '');
            const serObj = this.serviceDurationGridInfo.find(x => x.durationUnits === data);
            if (serObj !== null && serObj !== undefined) {
                this.serviceDurationEnable = true;
            }
        });
        // this.serviceDurationForm.get('duration')?.valueChanges.subscribe((data: number) => {
        //     this.serviceDurationEnable = false;
        //     const serObj = this.serviceDurationGridInfo.find(x => x.duration === data);
        //     if (serObj !== null && serObj !== undefined) {
        //         this.serviceDurationEnable = true;
        //     }
        // });
        this.coverageLevelForm.get('coverageLevel')?.valueChanges.subscribe((data: string) => {
            this.coverageLevEnable = false;
            data = data.replace('"', '');
            const covObj = this.coverageGridInfo.find(x => x.coverageLevelName === data);
            if (covObj !== null && covObj !== undefined) {
                this.coverageLevEnable = true;
            }
        });
        this.coverageLevelForm.get('noOfBeams')?.valueChanges.subscribe((data: string) => {
            this.coverageLevEnable = false;
            // data = data.replace('"', '');
            const covObj = this.coverageGridInfo.find(x => x.numberOfBeams === data);
            if (covObj !== null && covObj !== undefined) {
                this.coverageLevEnable = true;
            }
        });
        this.rxManufacturerForm.get('manufactureName')?.valueChanges.subscribe((data: string) => {
            this.rxManfuEnable = false;
            data = data.replace('"', '');
            const rxObj = this.rxManufacturersGridInfo.find(x => x.manufacturerName === data);
            if (rxObj !== null && rxObj !== undefined) {
                this.rxManfuEnable = true;
            }
        });

        this.loadSystemConfigurations();
    }

    public onChangeBeams(event : number): void {
        if (this.beamCount < event) {
            this.coverageLevelForm.get('noOfBeams')?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/), Validators.max(this.beamCount), Validators.min(1)]);
            this.coverageLevelForm.get('noOfBeams')?.updateValueAndValidity();
        }
        // if (this.coverageLevelForm.value?.coverageLevel === 'Global') {
        // if (event.toUpperCase() === 'ALL') {
        //     this.coverageLevelForm.get('noOfBeams')?.clearValidators();
        //     this.coverageLevelForm.get('noOfBeams')?.updateValueAndValidity();
        // } else {
        //     this.coverageLevelForm.get('noOfBeams')?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/), Validators.max(9), Validators.min(1)]);
        //     this.coverageLevelForm.get('noOfBeams')?.updateValueAndValidity();
        // }
        // }
        // else {
        //     this.coverageLevelForm.get('noOfBeams')?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/), Validators.max(9), Validators.min(1)]);
        //     this.coverageLevelForm.get('noOfBeams')?.updateValueAndValidity();
        // }
    }

    public onFocusOut(event : { value : number }) : void {
        if (this.testActivationLimit === null) {
            this.showMessage = '';
            this.testActivationLimit = this.initialTestActivationLimit.toString();
        }
    }

    public onFocusOutActivation(event : { value : number}) : void {
        if (this.supportActivationLimit === null) {
            this.showErrorMessage = '';
            this.supportActivationLimit = JSON.parse(JSON.stringify(this.initialSupportActivationLimit.toString()));
        }
    }

    public loadSystemConfigurations(): void {
        this._progressIndicatingService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Loading System Option Details',
                details: 'Please wait...',
                done: false
            }
        });
        this.loading = true;
        this.isError = false;
        this.isDataAvailable = false;
        this._systemConfigService.getSystemConfigInfo().pipe(
            filter((response: SystemConfigurationResponseDTO): boolean => response.responseCode === 0),
            map((response: SystemConfigurationResponseDTO): SystemConfigurations => response.configurations!)
        ).subscribe((configurations: SystemConfigurations) => {
            this.loading = false;
            this.isDataAvailable = true;
            this.configDTO = JSON.parse(JSON.stringify(configurations));
            this.beamsGridInfo = configurations.beams!;
            this.beamCount = this.beamsGridInfo.length;
            this.coverageGridInfo = configurations.coverageLevels!;
            this.serviceDurationGridInfo = configurations.serviceDurations!;
            this.serviceDurationGridInfo.sort((a, b) => {
                if (a.durationUnits === b.durationUnits) {
                    return a.duration! - b.duration!;
                } else {
                    return a.durationUnits! > b.durationUnits! ? -1 : 1;
                }
            });
            this.rxManufacturersGridInfo = configurations.receiverManufacturers!;
            this.partnersGridInfo = configurations.partners!;
            // this.partnersGridInfo.sort((a, b) => a.organizationId! - b.organizationId!);
            this.initialTestActivationLimit = JSON.parse(JSON.stringify(configurations.testDuration!));
            this.testActivationLimit = JSON.parse(JSON.stringify(this.initialTestActivationLimit!));
            this.testActivationLimitAPIData = JSON.parse(JSON.stringify(configurations.testDuration!));

            this.initialSupportActivationLimit = JSON.parse(JSON.stringify(configurations.customerSupportActivationDuration!));
            this.supportActivationLimit = JSON.parse(JSON.stringify(this.initialSupportActivationLimit!));
            this.supportActivationLimitAPIData = JSON.parse(JSON.stringify(configurations.customerSupportActivationDuration!));
            this.sendProgressDoneSignal();
        }, (error) => {
            this.loading = false;
            this.isDataAvailable = false;
            this.isError = true;
            this.errorMessage = error.error.responseMessage;
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: 'Unable to load system configurations. Please try again.' });
            this.sendProgressDoneSignal();
        });
    }

    private sendProgressDoneSignal(): void {
        this.progress$.next({
            header: '',
            done: true
        });
    }

    public onAddItem(): void {
        if (this.onAddDialogHeader === 'Add New Beam') {
            // this.loading = true;
            // this.spnieerMsg = 'Submitting Data';
            this._progressIndicatingService.show({
                progress$: this.progress$.asObservable(),
                initial: {
                    header: 'Adding New Beam',
                    details: 'Please wait...',
                    done: false
                }
            });
            this._systemConfigService.addNewBeam(this._dataTranslationService.translateToAddNewBeamPostRequest(this.addNewDetailsForm.value.newBeam, this.addNewDetailsForm.value.newLongitude)).pipe(
                filter((response: BeamResponseDTO) => response.responseCode === 0 || response.responseCode !== 0))
                .subscribe((data: BeamResponseDTO) => {
                    this.onRequestComplete();
                    this.sendProgressDoneSignal();
                    this.apiResponsePopup(data.responseMessage!, data.responseCode!);
                }, error => {
                    this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
                    this.sendProgressDoneSignal();
                    this.onRequestComplete();
                });
        }
        if (this.onAddDialogHeader === 'Add Coverage Level') {
            this._progressIndicatingService.show({
                progress$: this.progress$.asObservable(),
                initial: {
                    header: 'Adding new coverage level',
                    details: 'Please wait...',
                    done: false
                }
            });
            this._systemConfigService.addNewCoverage(this._dataTranslationService.translateToAddNewCovergaePostRequest(this.addNewDetailsForm.value.newCoverageLevel, +this.addNewDetailsForm.value.newNoOfBeams))
                .pipe(
                    filter((response: CoverageLevelResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0)
                ).subscribe((data: CoverageLevelResponseDTO) => {
                    this.onRequestComplete();
                    this.sendProgressDoneSignal();
                    this.apiResponsePopup(data.responseMessage!, data.responseCode!);
                }, error => {
                    this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
                    this.sendProgressDoneSignal();
                    this.onRequestComplete();
                });
        }
        if (this.onAddDialogHeader === 'Add Service Duration') {
            this._progressIndicatingService.show({
                progress$: this.progress$.asObservable(),
                initial: {
                    header: 'Adding new service duration',
                    details: 'Please wait...',
                    done: false
                }
            });
            this._systemConfigService.addNewDuration(this._dataTranslationService.translateToAddServiceDurationPostRequest(+this.addNewDetailsForm.value.newDuration, this.addNewDetailsForm.value.newDurationUnits.toUpperCase()))
                .pipe(
                    filter((response: CoverageLevelResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0)
                ).subscribe((data: CoverageLevelResponseDTO) => {
                    this.onRequestComplete();
                    this.sendProgressDoneSignal();
                    this.apiResponsePopup(data.responseMessage!, data.responseCode!);
                }, error => {
                    this.sendProgressDoneSignal();
                    this.onRequestComplete();
                    this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
                });
        }
        if (this.onAddDialogHeader === 'Add Manufacturer') {
            this._progressIndicatingService.show({
                progress$: this.progress$.asObservable(),
                initial: {
                    header: 'Adding new manufacturer',
                    details: 'Please wait...',
                    done: false
                }
            });
            this._systemConfigService.addNewRxManufacturer(this._dataTranslationService.translateToAddRxManafacturerPostRequest(this.addNewDetailsForm.value.newManufactureName))
                .pipe(
                    filter((response: CoverageLevelResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0)
                ).subscribe((data: CoverageLevelResponseDTO) => {
                    this.onRequestComplete();
                    this.sendProgressDoneSignal();
                    this.apiResponsePopup(data.responseMessage!, data.responseCode!);
                }, error => {
                    this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
                    this.sendProgressDoneSignal();
                    this.onRequestComplete();
                });
        }
        this.onAddItems = false;
        this.onAddPartnerItems = false;
        this.onAddDialogHeader = '';
    }

    public onModalDialogHide(): void {
        this.newBeam = '';
        this.newBeamLongitude = '';
        this.newCoverage = '';
        this.newCoverageBeams = '';
        this.newDuration = '';
        this.newDurationUnits = '';
        this.newrxManufacturers = '';
        this.newPartnerEmail = '';
        this.newPartnerName = '';
        this.selectedNewPartnerType = '';
        this.onAddItems = false;
        this.addNewDetailsForm.reset();
        this.addNewDetailsForm.clearValidators();
    }

    public enableSingleRow(id: string): void {
        const cancel = document.getElementById(id);
        if (cancel) {
            cancel.click();
        }
    }

    public onRowEditInit(beam: BeamIndentification): void {
        this.clonedBeams[beam.beamId!] = { ...beam };
        this.beamForm.patchValue({
            beamId: beam.beamId,
            satelliteLongitude: beam.satelliteLongitude
        });
        this.enableSingleRow('beamcancel');
    }

    public onRowEditSave(product: BeamIndentification): void {
        product.beamId = this.beamForm.value.beamId;
        product.satelliteLongitude = this.beamForm.value.satelliteLongitude;
        this._progressIndicatingService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Updating beams in progress',
                details: 'Please wait...',
                done: false
            }
        });
        this._systemConfigService.updateBeams(this._dataTranslationService.translateToUpdateBeamPutRequest(product)).pipe(
            filter((response: BeamResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0),
            map((response: BeamResponseDTO): BeamResponseDTO => response!)
        ).subscribe((responseMsg: BeamResponseDTO) => {
            this.onRequestComplete();
            this.sendProgressDoneSignal();
            this.apiResponsePopup(responseMsg.responseMessage!, responseMsg.responseCode!);
        }, error => {
            this.beamsGridInfo = JSON.parse(JSON.stringify(this.configDTO.beams!));
            this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
            this.sendProgressDoneSignal();
            this.onRequestComplete();
        });
    }

    public onRowEditCancel(beam: BeamIndentification, index?: number): void {
        delete this.clonedBeams[beam.beamId!];
    }

    public onAddBeam(): void {
        this.onAddItems = true;
        this.onAddDialogHeader = 'Add New Beam';
    }

    public onDelete(beam: BeamIndentification): void {
        this.confirmCancel('Do you want to delete the selected Beam ' + ` '${beam.beamId}'`, 'beam', beam.beamId!);
    }

    public onCoverageRowEditInit(coverage: CoverageLevel): void {
        this.coverageLevelForm.patchValue({
            coverageLevel: coverage.coverageLevelName,
            noOfBeams: coverage.numberOfBeams
        });
        this.clonedCoverages[coverage.coverageLevelName!] = { ...coverage };
        this.enableSingleRow('coveragecancel');
    }

    public onCoverageRowEditSave(coverage: CoverageLevel): void {
        coverage.coverageLevelName = this.coverageLevelForm.value.coverageLevel;
        coverage.numberOfBeams = this.coverageLevelForm.value.noOfBeams;

        this._progressIndicatingService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Updating coverage level\'s in progress',
                details: 'Please wait...',
                done: false
            }
        });
        this._systemConfigService.updateCoverage(this._dataTranslationService.translateToUpdateCovergaePutRequest(coverage)).pipe(
            filter((response: BeamResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0),
            map((response: BeamResponseDTO): BeamResponseDTO => response!)
        ).subscribe((responseMsg: BeamResponseDTO) => {
            this.onRequestComplete();
            this.sendProgressDoneSignal();
            this.apiResponsePopup(responseMsg.responseMessage!, responseMsg.responseCode!);
        }, error => {
            this.coverageGridInfo = JSON.parse(JSON.stringify(this.configDTO.coverageLevels!));
            this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
            this.sendProgressDoneSignal();
            this.onRequestComplete();
        });
    }

    public onCoverageRowEditCancel(coverage: CoverageLevel, index?: number): void {
        delete this.clonedCoverages[coverage.coverageLevelId!];
    }

    public onCoverageDelete(coverage: CoverageLevel): void {
        this.confirmCancel('Do you want to delete the selected Coverage ' + ` '${coverage.coverageLevelName}'`, 'coverage', coverage.coverageLevelId!);
    }

    public onAddCoverage(): void {
        this.onAddItems = true;
        this.onAddDialogHeader = 'Add Coverage Level';
    }

    public onDurationRowEditInit(duration: ServiceDuration): void {
        this.serviceDurationForm.patchValue({
            duration: duration.duration,
            durationUnits: duration.durationUnits
        });
        this.clonedServiceDurations[duration.serviceDurationId!] = { ...duration };
        this.enableSingleRow('durationcancel');
    }

    public onDurationRowEditSave(duration: ServiceDuration): void {
        duration.duration = this.serviceDurationForm.value.duration;
        duration.durationUnits = this.serviceDurationForm.value.durationUnits;
        this._progressIndicatingService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Updating duration in progress',
                details: 'Please wait...',
                done: false
            }
        });
        this._systemConfigService.updateDuration(this._dataTranslationService.translateToUpdateServiceDurationPutRequest(duration)).pipe(
            filter((response: BeamResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0),
            map((response: BeamResponseDTO): BeamResponseDTO => response!)
        ).subscribe((responseMsg: BeamResponseDTO) => {
            this.onRequestComplete();
            this.sendProgressDoneSignal();
            this.apiResponsePopup(responseMsg.responseMessage!, responseMsg.responseCode!);
        }, error => {
            this.onRequestComplete();
            this.sendProgressDoneSignal();
            this.apiResponsePopup(error.error.responseMessage, error.error.responseCode);
            this.serviceDurationGridInfo = JSON.parse(JSON.stringify(this.configDTO.serviceDurations!));
            this.serviceDurationGridInfo.sort((a, b) => {
                if (a.durationUnits === b.durationUnits) {
                    return a.duration! - b.duration!;
                } else {
                    return a.durationUnits! > b.durationUnits! ? -1 : 1;
                }
            });
            // this.serviceDurationGridInfo.forEach(x => {
            //     const duration = this.clonedServiceDurations[x.serviceDurationId!];
            //     if (x.serviceDurationId === duration.serviceDurationId) {
            //         x.duration = duration.duration;
            //         x.durationUnits = duration.durationUnits;
            //     }
            // });
        });
    }

    public onDurationRowEditCancel(duration: ServiceDuration, index?: number): void {
        delete this.clonedServiceDurations[duration.serviceDurationId!];
    }

    public onDurationDelete(duration: ServiceDuration): void {
        this.confirmCancel('Do you want to delete the selected service duration ' + ` '${duration.duration}'`, 'duration', duration.serviceDurationId!);
    }

    public onAddServiceDuration(): void {
        this.onAddItems = true;
        this.onAddDialogHeader = 'Add Service Duration';
    }

    public onRxManfRowEditInit(rxManf: ReceiverManufacturer): void {
        this.rxManufacturerForm.patchValue({
            manufactureName: rxManf.manufacturerName
        });
        this.clonedrxManufacturers[rxManf.manufacturerId!] = { ...rxManf };
        this.enableSingleRow('rxmanfcancel');
    }

    public onRxManfRowEditSave(rxManf: ReceiverManufacturer): void {
        rxManf.manufacturerName = this.rxManufacturerForm.value.manufactureName;

        this._progressIndicatingService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Updating manufacturer in progress',
                details: 'Please wait...',
                done: false
            }
        });
        this._systemConfigService.updateRxManufacturer(this._dataTranslationService.translateToUpdateRxManufacturerPutRequest(rxManf)).pipe(
            filter((response: BeamResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0)
        ).subscribe((responseMsg: BeamResponseDTO) => {
            this.onRequestComplete();
            this.sendProgressDoneSignal();
            this.apiResponsePopup(responseMsg.responseMessage!, responseMsg.responseCode!);
        }, error => {
            this.rxManufacturersGridInfo = JSON.parse(JSON.stringify(this.configDTO.receiverManufacturers!));
            this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
            this.sendProgressDoneSignal();
            this.onRequestComplete();
        });
    }

    public onRxManfRowEditCancel(rxManf: ReceiverManufacturer, index?: number): void {
        delete this.clonedrxManufacturers[rxManf.manufacturerId!];
    }

    public onRxManfDelete(rxManf: ReceiverManufacturer): void {
        this.confirmCancel('Do you want to delete the selected Receiver Manufacturer ' + ` '${rxManf.manufacturerName}'`, 'rx', rxManf.manufacturerId!);
    }

    public onAddRxManufacturer(): void {
        this.onAddItems = true;
        this.onAddDialogHeader = 'Add Manufacturer';
    }

    public onPartnerRowEditInit(partner: Partners): void {
        this.clonedPartners[partner.organizationId!] = { ...partner };
        this.enableSingleRow('rxmanfcancel');
        this.sendNewData(partner);
        this._router.navigate(['/admin/partner']);
    }

    public sendNewData(data: Partners): void {
        this._partnerDataService.sendData(data);
    }

    public onPartnerDelete(partner: Partners): void {
        this.confirmCancel('Do you want to delete the selected partner ' + ` '${partner.organizationDisplayName}'`, 'partner', partner.organizationId!);
    }

    public onAddPartner(): void {
        this.clonedPartners = {};
        // this.onAddItems = true;
        this.onAddPartnerItems = true;
        this.onAddDialogHeader = 'Add Partner';
        this._router.navigate(['/admin/partner']);
    }

    public confirmCancel(message: string, type: string, id: string | number): void {
        this._confirmationService.confirm({
            message: message,
            header: 'Confirmation',
            icon: 'pi pi-info-circle',
            acceptLabel: 'Ok',
            acceptVisible: true,
            rejectLabel: 'Cancel',
            rejectVisible: true,
            accept: () => {
                if (type === 'beam') {
                    this._progressIndicatingService.show({
                        progress$: this.progress$.asObservable(),
                        initial: {
                            header: 'Deleting Beam',
                            details: 'Please wait...',
                            done: false
                        }
                    });
                    this._systemConfigService.deleteBeam(id).pipe(
                        filter((response: ResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0),
                        map((response: ResponseDTO): ResponseDTO => response))
                        .subscribe((data: ResponseDTO) => {
                            this.onRequestComplete();
                            this.sendProgressDoneSignal();
                            this.apiResponsePopup(data.responseMessage!, data.responseCode!);
                        }, error => {
                            this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
                            this.sendProgressDoneSignal();
                            this.onRequestComplete();
                        });
                }
                if (type === 'coverage') {
                    this._progressIndicatingService.show({
                        progress$: this.progress$.asObservable(),
                        initial: {
                            header: 'Deleting coverage',
                            details: 'Please wait...',
                            done: false
                        }
                    });
                    this._systemConfigService.deleteCoverage(id).pipe(
                        filter((response: ResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0),
                        map((response: ResponseDTO): ResponseDTO => response))
                        .subscribe((data: ResponseDTO) => {
                            this.onRequestComplete();
                            this.sendProgressDoneSignal();
                            this.apiResponsePopup(data.responseMessage!, data.responseCode!);
                        }, error => {
                            this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
                            this.sendProgressDoneSignal();
                            this.onRequestComplete();
                        });
                }
                if (type === 'duration') {
                    this._progressIndicatingService.show({
                        progress$: this.progress$.asObservable(),
                        initial: {
                            header: 'Deleting duration',
                            details: 'Please wait...',
                            done: false
                        }
                    });
                    this._systemConfigService.deleteDuration(id).pipe(
                        filter((response: ResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0),
                        map((response: ResponseDTO): ResponseDTO => response))
                        .subscribe((data: ResponseDTO) => {
                            this.onRequestComplete();
                            this.sendProgressDoneSignal();
                            this.apiResponsePopup(data.responseMessage!, data.responseCode!);
                        }, error => {
                            this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
                            this.sendProgressDoneSignal();
                            this.onRequestComplete();
                        });
                }
                if (type === 'rx') {
                    this._progressIndicatingService.show({
                        progress$: this.progress$.asObservable(),
                        initial: {
                            header: 'Deleting Manufacturer',
                            details: 'Please wait...',
                            done: false
                        }
                    });
                    this._systemConfigService.deleteRxManufacturer(id).pipe(
                        filter((response: ResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0))
                        .subscribe((data: ResponseDTO) => {
                            this.onRequestComplete();
                            this.sendProgressDoneSignal();
                            this.apiResponsePopup(data.responseMessage!, data.responseCode!);
                        }, error => {
                            this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
                            this.sendProgressDoneSignal();
                            this.onRequestComplete();
                        });
                }
                if (type === 'partner') {
                    this._progressIndicatingService.show({
                        progress$: this.progress$.asObservable(),
                        initial: {
                            header: 'Deleting partner',
                            details: 'Please wait...',
                            done: false
                        }
                    });
                    this._systemConfigService.deletePartner(id).pipe(
                        filter((response: ResponseDTO): boolean => response.responseCode === 0 || response.responseCode !== 0))
                        .subscribe((data: ResponseDTO) => {
                            this.onRequestComplete();
                            this.sendProgressDoneSignal();
                            this.apiResponsePopup(data.responseMessage!, data.responseCode!);
                        }, error => {
                            this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
                            this.sendProgressDoneSignal();
                            this.onRequestComplete();
                        });
                }
            }
        });
    }

    private apiResponsePopup(responseMsg: string, responseCode: number) {
        // this.errorResponseCode = false;
        // if (responseCode !== 0) {
        //     this.errorResponseCode = true;
        // }
        if (responseCode === 0) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: responseMsg });
            this.loadSystemConfigurations();
        } else {
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: responseMsg });
        }
        // this._confirmationService.confirm({
        //     message: responseMsg,
        //     icon: 'pi pi-info-circle',
        //     acceptLabel: 'Ok',
        //     acceptVisible: true,
        //     rejectVisible: false,
        //     accept: () => {
        //         if (responseCode === 0) {
        //             this.loadSystemConfigurations();
        //         }
        //     }
        // });
    }

    private onRequestComplete() {
        this.loading = false;
        this.spnieerMsg = '';
    }

    public onTestLimitChange(event: { value: number }) {
        this.testActivationLimit = JSON.parse(JSON.stringify(event.value));
        if (event.value === 0 || event.value === null || event.value > 1825) {
            this.isTestActivationLimitChanged = true;
            this.showMessage = 'Maximum Test Activation should be 1825';
            return;
        } else {
            this.showMessage = '';
        }
        if (this.testActivationLimitAPIData !== event.value) {
            this.isTestActivationLimitChanged = false;
        } else {
            this.isTestActivationLimitChanged = true;
        }
    }

    public onSaveTestActivationLimit() {
        this.isTestActivationLimitChanged = true;
        this._progressIndicatingService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Saving Test Activation',
                details: 'Please wait...',
                done: false
            }
        });
        this._systemConfigService.updateTestActivationLimit(+this.testActivationLimit!).pipe(
            filter((response: ResponseDTO) => response.responseCode === 0 || response.responseCode !== 0))
            .subscribe((data: ResponseDTO) => {
                this.onRequestComplete();
                this.sendProgressDoneSignal();
                this.apiResponsePopup(data.responseMessage!, data.responseCode!);
            }, error => {
                this.onRequestComplete();
                this.sendProgressDoneSignal();
                this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
            });
    }

    public onSaveSupportActivationLimit() : void {
        this.issupportActivationLimitChanged = true;
        this._progressIndicatingService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Saving Customer Support Activation Duration',
                details: 'Please wait...',
                done: false
            }
        });
        this._systemConfigService.updateSupportActivationLimit(+this.supportActivationLimit!).pipe(
            filter((response: ResponseDTO) => response.responseCode === 0 || response.responseCode !== 0))
            .subscribe((data: ResponseDTO) => {
                this.onRequestComplete();
                this.sendProgressDoneSignal();
                this.apiResponsePopup(data.responseMessage!, data.responseCode!);
            }, error => {
                this.onRequestComplete();
                this.sendProgressDoneSignal();
                this.apiResponsePopup(error.error.responseMessage!, error.error.responseCode!);
            });
    }

    public onSupportLimitChange(event: { value: number }) : void {
        this.supportActivationLimit = JSON.parse(JSON.stringify(event.value));
        if (event.value === 0 || event.value === null || event.value > 1825) {
            this.issupportActivationLimitChanged = true;
            this.showErrorMessage = 'Maximum Customer Activation should be 1825';
            return;
        } else {
            this.showErrorMessage = '';
        }
        if (this.supportActivationLimitAPIData !== event.value) {
            this.issupportActivationLimitChanged = false;
        } else {
            this.issupportActivationLimitChanged = true;
        }
    }

    public onCancel(event: Event): void {
        this.onAddItems = false;
        event?.preventDefault();
        this.addNewDetailsForm.reset();
        this.addNewDetailsForm.clearValidators();
    }

    public disableAddItems(): boolean {
        if ((this.addNewDetailsForm.controls.newBeam.invalid || this.addNewDetailsForm.controls.newLongitude.invalid) &&
        (this.addNewDetailsForm.controls.newDuration.invalid || this.addNewDetailsForm.controls.newDurationUnits.invalid) &&
        (this.addNewDetailsForm.controls.newCoverageLevel.invalid || this.addNewDetailsForm.controls.newNoOfBeams.invalid || this.beamCount < this.addNewDetailsForm.value.newNoOfBeams) &&
        (this.addNewDetailsForm.controls.newManufactureName.invalid)) {
            return true;
        }
        return false;
    }
}
